module.exports = __webpack_public_path__ + "6d9bed8e341864e65a0e8b955d66ac09.jpg";